import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { Observable } from 'rxjs';

import { MapsService } from '../services/maps.service';

@Injectable({ providedIn: 'root' })
export class MapResolver implements Resolve<boolean> {
  private mapsService = inject(MapsService);

  resolve(): Observable<boolean> | boolean {
    return this.mapsService.load();
  }
}
